import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'methaneLevel' })
export class MethaneLevelPipe implements PipeTransform {
    transform(value: MethaneLevel, ...args: any[]): any {
        // maybe sync automatically with locale-en.json?
        switch (value) {
            case 'H_GAS':
                return 'H-gas';
            case 'L_GAS':
                return 'L-gas';
        }
    }
}
